import { useEffect, useState } from 'react';
import { HugeiconsIcon } from '@hugeicons/react';
import { ColorPickerIcon, Moon02Icon, Sun03Icon } from '@hugeicons/core-free-icons';
import { Button } from '@/components/ui/button';

const THEMES = ['dark', 'light', 'purple'];
const ICONS = { dark: Moon02Icon, light: Sun03Icon, purple: ColorPickerIcon };
const LABELS = { dark: 'Oscuro', light: 'Claro', purple: 'Purple UC' };

export function ThemeToggle() {
  const [theme, setTheme] = useState(() => {
    if (typeof window !== 'undefined') return localStorage.getItem('via-theme') || 'light';
    return 'light';
  });

  useEffect(() => {
    const root = document.documentElement;
    root.classList.remove('dark', 'light', 'purple');
    root.classList.add(theme);
    localStorage.setItem('via-theme', theme);
  }, [theme]);

  const cycle = () => {
    const index = THEMES.indexOf(theme);
    setTheme(THEMES[(index + 1) % THEMES.length]);
  };

  return (
    <Button
      variant="ghost"
      size="icon"
      onClick={cycle}
      className="h-8 w-8 hover:bg-white/10"
      title={`Tema: ${LABELS[theme]} — click para cambiar`}>
      <HugeiconsIcon
        icon={ICONS[theme] || Moon02Icon}
        className="text-header-muted transition-colors hover:text-header"
      />
    </Button>
  );
}
